// extracted by mini-css-extract-plugin
export default {"content":"CBxZ8w","ellipsisStart":"wcHvUg"};